import { z } from "zod";

/** Mirrors `WaitlistService`. */
export const waitlistServiceSchema = z.object({ id: z.string(), name: z.string() });

/**
 * Mirrors `MyWaitlistItem` (Phase 4 design D1): one day the customer is waiting for. `Notified`
 * means a time opened and they were told; nothing was held for them.
 */
export const myWaitlistItemSchema = z.object({
  id: z.string(),
  day: z.string(),
  status: z.enum(["Waiting", "Notified"]),
  services: z.array(waitlistServiceSchema),
  staffId: z.string().nullable(),
  staffName: z.string().nullable(),
  notifiedAt: z.string().nullable(),
});

export const myWaitlistSchema = z.array(myWaitlistItemSchema);

export type MyWaitlistItem = z.infer<typeof myWaitlistItemSchema>;

export interface JoinWaitlistInput {
  /** yyyy-mm-dd in the salon's zone. */
  day: string;
  serviceIds: readonly string[];
  staffId: string | null;
}
